// modules/EnquiryButton.js
import React         from 'react';
import Arrow  from '../images/arrow';

class FlyerButton extends React.Component {
	render() {
		if (this.props.link) {
			var d = new Date();
			var link = this.props.link + "?ts=" + d.getTime();
			return (
				<a href={link} target="_blank">
					<div className={this.props.bclass}>
						<div>{this.props.children}<Arrow/></div>
					</div>
				</a>
			);
		} else {
			return null;
		}
	}
}

export default FlyerButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/FlyerButton.js
 **/